// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowsRepeat16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrows-repeat': IconArrowsRepeat;
    }
}

/**
 * The icon component for the 'arrowsRepeat' icon
 */
export class IconArrowsRepeat extends IconSvg {
    public constructor() {
        super(arrowsRepeat16X16);
    }
}

registerIconSvg('icon-arrows-repeat', IconArrowsRepeat);
export const iconArrowsRepeatTag = 'nimble-icon-arrows-repeat';
